import styled from "styled-components";
import { Box } from "@mui/material";

const OFFSETS: Record<string, string> = {
	up: "translateY(36px)",
	left: "translateX(-36px)",
	right: "translateX(36px)"
};

export const RevealWrapper = styled(Box)<{ $direction: "up" | "left" | "right" }>`
	opacity: 0;
	transform: ${({ $direction }) => OFFSETS[$direction]};
	transition:
		opacity 0.7s cubic-bezier(0.22, 1, 0.36, 1),
		transform 0.7s cubic-bezier(0.22, 1, 0.36, 1);
	will-change: opacity, transform;

	&.in-view {
		opacity: 1;
		transform: translate(0, 0);
	}
`;
